import React from 'react';
import PropTypes from 'prop-types';
import { get, has } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { Image } from '@bd/bdcore-utilities';
import LightBox from '@bd/bdui-lightbox';
import { CSSTransitionGroup } from 'react-transition-group';
import { colors } from '../styles';

const styles = css`
  width: 100%;
  background-color: ${colors.white};
  padding: 0;
  margin: 0;
  position: relative;
  @media (min-width: 992px) {
    margin: 0;
  }
  .Carousel_slideWrapper {
    position: relative;
    z-index: 0;
    overflow: hidden;
  }
  .Carousel_thumbnailsWrapper {
    display: none;
    position: relative;
    @media (min-width: 992px) {
      display: block;
      margin: 10px 0 0 0;
    }
  }
  .Carousel_thumbnails {
    list-style: none;
    margin: 0;
    padding: 0;
    white-space: nowrap;
    overflow-x: scroll;
    scroll-behavior: smooth;
  }
  .Carousel_thumbnailItem {
    display: inline-block;
    white-space: nowrap;
    position: relative;
    margin: 0 5px 0 0;
    width: 20%;
    background-color: transparent;
  }
  .Carousel_thumbnailItem:after {
    display: none;
    content: " ";
    top: auto;
    bottom: 0;
    right: 0;
    left: 0;
    height: 8px;
    border-top: 1px solid ${colors.white};
    position: absolute;
    background-color: ${colors.brand1};
    z-index: 1;
    pointer-events: none;
  }
  .Carousel_thumbnailItem-active:after {
    display: block;
  }
  img {
    width: 100%;
    height: auto;
  }
  .Carousel_videoOverlay {
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-image: url('/images/icon-video-white.svg');
    background-position: center center;
    background-size: 32px 32px;
    background-repeat: no-repeat;
  }
  .Carousel_tourOverlay {
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-image: url('/images/icon-tour-white.svg');
    background-position: center center;
    background-size: auto 34px;
    background-repeat: no-repeat;
  }

   .Carousel_image {
    display: block;
    position: relative;
    padding-bottom: 56.25%;
    img {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
    }
    .Carousel_imageElement {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 1;
      margin: 0;
      padding: 0;
      width: 100%;
    }
    iframe {
      position: relative;
      width: 100%;
      height: 100%;
    }
    iframe {
      position: relative;
      width: 100%;
      height: 100%;
    }
  }
  .Carousel_imageButtonLeft, .Carousel_imageButtonRight {
    position: absolute;
    display: block;
    top: 40%;
    width: 24px;
    height: 40px;
    background-size: 12px 20px;
    background-position: center center;
    background-repeat: no-repeat;
    background-image: url(/images/icon-arrow-right-white-shadow.svg);
    z-index: 2;
    cursor: pointer;
    @media (min-width: 992px) {
      top: 45%;
      background-size: 17px 29px;
    }
  }
  .Carousel_imageButtonRight{
    position:absolute;
    right:1em;
    left: auto;
  }
  .Carousel_imageButtonLeft{
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
    right: auto;
    left: 1em;
  }
  .Carousel_imageEnlarge {
    position: absolute;
    display: block;
    width: 30px;
    height: 30px;
    right: 10px;
    bottom: 10px;
    cursor: pointer;
    z-index: 2;
  }
  .Carousel_imageEnlargeButton {
    background-image: url(/images/icon-enlarge-white.svg);
    background-position: center center;
    background-size: 27px 27px;
    background-repeat: no-repeat;
  }
  .Carousel_imageEnlarge {
    position: absolute;
    display: block;
    width: 30px;
    height: 30px;
    right: 10px;
    bottom: 10px;
    cursor: pointer;
    z-index: 2;
  }
  .Carousel_imageEnlargeButton {
    background-image: url(/images/icon-enlarge-white.svg);
    background-position: center center;
    background-size: 27px 27px;
    background-repeat: no-repeat;
  }
  .Carousel_indicatorList {
    width: 100%;
    text-align: center;
    padding: 0;
    margin: 20px 0 40px;
    position: absolute;
    bottom: 0;
    & > li {
      display: inline-block;
    }
  }
  .Carousel_indicator {
    width: 30px;
    height: 4px;
    background-color: ${colors.body};
    display: inline-block;
    margin: 0 2px;
    cursor: pointer;
    &-active {
      background-color: ${colors.white};
    }
  }

  .Carousel_imageAnimation {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 0;
  }
/** Fade Animation */
  /* .Carousel_imageAnimation-enter {
  }

  .Carousel_imageAnimation-enter-active {
  }

  .Carousel_imageAnimation-leave {
    z-index: 2;
    opacity: 1;
  }

  .Carousel_imageAnimation-leave-active {
    opacity: 0;
    transition: all 750ms ease-in;
  } */
/** End Fade Animation */

/** Slide Animation  */

  .Carousel_image-right {
    .Carousel_imageAnimation-enter {
      transform: translateX(100%);
    }

    .Carousel_imageAnimation-enter-active {
      transform: translateX(0%);
      transition: all 750ms ease-out;
    }

    .Carousel_imageAnimation-leave {
      transform: translateX(0%);
      z-index: 2;
    }

    .Carousel_imageAnimation-leave-active {
      transform: translateX(-100%);
      transition: all 750ms ease-out;
    }
  }

  .Carousel_image-left {
    .Carousel_imageAnimation-enter {
      transform: translateX(-100%);
    }

    .Carousel_imageAnimation-enter-active {
      transform: translateX(0%);
      transition: all 750ms ease-out;
    }

    .Carousel_imageAnimation-leave {
      transform: translateX(0%);
      z-index: 2;
    }

    .Carousel_imageAnimation-leave-active {
      transform: translateX(100%);
      transition: all 750ms ease-out;
    }
  }

  /** End Slide Animation */

`;

class Carousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSlideIndex: 0,
      direction: 'right',
    };

    this.pause = false;
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll);
    if (this.props.autoplay) {
      this.startAutoplay();
    }
  }

  componentDidUpdate() {
    if (!this.props.autoplay) {
      this.stopAutoplay();
    } else {
      this.startAutoplay();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
    if (this.interval) {
      this.stopAutoplay();
    }
  }

  setThumbnailListRef = ref => {
    this.thumbnailListRef = ref;
  }

  startAutoplay = () => {
    if (!this.interval) {
      this.interval = setInterval(this.handleInterval, this.props.interval);
    }
  }

  stopAutoplay = () => {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }


  handleThumbnailClick = index => event => {
    if (event.which && ![13, 32].includes(event.which)) {
      return;
    }

    this.setState({
      currentSlideIndex: index,
      direction: this.state.currentSlideIndex < index ? 'right' : 'left',
    });
  }

  handlePrevClick = (event = {}) => {
    if (event.preventDefault) {
      event.preventDefault();
    }
    if (event.which && ![13, 32].includes(event.which)) {
      return;
    }

    const { items } = this.props;
    const { currentSlideIndex } = this.state;
    const prevIndex = (currentSlideIndex + (items.length - 1)) % items.length;
    this.setState({
      currentSlideIndex: prevIndex,
      direction: this.state.currentSlideIndex < prevIndex ? 'right' : 'left',
    }, this.scrollToActive);
  }

  handleNextClick = (event = {}, timed) => {
    if (event.preventDefault) {
      event.preventDefault();
    }
    if (event.which && ![13, 32].includes(event.which)) {
      return;
    }

    const { items } = this.props;
    const { currentSlideIndex } = this.state;
    const nextIndex = (currentSlideIndex + 1) % items.length;
    this.setState({
      currentSlideIndex: nextIndex,
      direction: this.state.currentSlideIndex < nextIndex || timed ? 'right' : 'left',
    }, this.scrollToActive);
  }

  handleInterval = () => {
    if (!this.pause) {
      this.handleNextClick({}, true);
    }
  }

  handleMouseEnter = () => {
    this.pause = true;
  }

  handleMouseLeave = () => {
    this.pause = false;
  }

  handleTouchStart = event => {
    this.xDown = event.touches[0].clientX;
    this.yDown = document.documentElement.scrollTop || document.body.scrollTop;
  }

  handleTouchMove = event => {
    if (!this.xDown) {
      return;
    }

    if ((this.xDown - event.touches[0].clientX) > 0) {
      this.swipeDirection = 'left';
    } else if (this.state.currentSlideIndex !== 0) {
      this.swipeDirection = 'right';
    }

    this.xDown = null;
  }

  handleTouchEnd = event => {
    const scrollTop = (document.documentElement.scrollTop || document.body.scrollTop);

    if (Math.abs(scrollTop - this.yDown) < 50) {
      switch (this.swipeDirection) {
        case 'left':
          this.handleNextClick();
          break;
        case 'right':
          this.handlePrevClick();
          break;
        default:
          if (!this.cancelClick) {
            event.target.click();
          }
      }
    }

    this.swipeDirection = null;
    this.cancelClick = null;
    this.yDown = null;
  }

  handleScroll = () => {
    if (this.xDown) {
      const scrollTop = (document.documentElement.scrollTop || document.body.scrollTop);
      if (Math.abs(scrollTop - this.yDown) < 10) {
        this.cancelClick = true;
      }
    }
  }

  scrollToActive = () => {
    if (this.thumbnailListRef) {
      const [{ offsetLeft = 0, offsetWidth: thumbWidth }] = this.thumbnailListRef.getElementsByClassName('Carousel_thumbnailItem-active');
      const containerWidth = this.thumbnailListRef.offsetWidth;
      const scrollLeft = this.thumbnailListRef.scrollLeft;

      if ((offsetLeft + thumbWidth) > (
        containerWidth + scrollLeft
      )) {
        this.thumbnailListRef.scrollLeft = offsetLeft;
      } else if (offsetLeft < scrollLeft) {
        this.thumbnailListRef.scrollLeft = (offsetLeft + thumbWidth) - containerWidth;
      }
    }
  }

  render() {
    const {
      expandButton,
      expandButtonContent,
      indicators,
      items,
      thumbnails,
      thumbnailImageProps,
      mainImageProps,
      className,
    } = this.props;
    const { currentSlideIndex, direction } = this.state;
    const currentSlide = items[currentSlideIndex];

    return (
      <div
        className={`${styles} ${className}`}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <div
          onTouchStart={this.handleTouchStart}
          onTouchMove={this.handleTouchMove}
          onTouchEnd={this.handleTouchEnd}
          className="Carousel_slideWrapper"
        >
          <CSSTransitionGroup
            className={`Carousel_image Carousel_image-${direction}`}
            transitionName="Carousel_imageAnimation"
            transitionEnterTimeout={750}
            transitionLeaveTimeout={750}
            autoplay
          >
            {
              has(currentSlide, 'contentUrl') &&
                <Image
                  key={get(currentSlide, 'contentUrl')}
                  src={get(currentSlide, 'contentUrl')}
                  alt={get(currentSlide, 'name', get(currentSlide, 'caption', ''))}
                  {...mainImageProps}
                />
            }
            {
              has(currentSlide, 'element') &&
              <div key={get(currentSlide, 'key')} className="Carousel_imageAnimation">
                {get(currentSlide, 'element')}
              </div>
            }
          </CSSTransitionGroup>
          {
            currentSlideIndex > 0 &&
            <div
              role="button"
              tabIndex="0"
              onClick={this.handlePrevClick}
              onKeyDown={this.handlePrevClick}
              className="Carousel_imageButtonLeft"
            />
          }
          {
            items.length > 1 &&
            (currentSlideIndex + 1) < items.length &&
            <div
              role="button"
              tabIndex="0"
              onClick={this.handleNextClick}
              onKeyDown={this.handleNextClick}
              className="Carousel_imageButtonRight"
            />
          }
          {
            expandButton &&
            <LightBox items={items} enableZoom>
              <div className="Carousel_imageEnlarge" data-index={currentSlideIndex}>
                {
                  !expandButtonContent &&
                  <div className="Carousel_imageEnlargeButton" data-index={currentSlideIndex} />
                }
                {expandButtonContent}
              </div>
            </LightBox>
          }
        </div>
        {
          thumbnails &&
          <div className="Carousel_thumbnailsWrapper">
            <ul className="Carousel_thumbnails" ref={ref => this.setThumbnailListRef(ref)}>
              {
                items.map((item, i) => (
                  <li key={i.toString()} className={`Carousel_thumbnailItem ${currentSlideIndex === i ? 'Carousel_thumbnailItem-active' : ''}`}>
                    <span
                      role="button"
                      tabIndex="0"
                      onClick={this.handleThumbnailClick(i)}
                      onKeyDown={this.handleThumbnailClick(i)}
                    >
                      {
                        has(item, 'contentUrl') &&
                        <Image
                          src={get(item, 'contentUrl')}
                          alt={get(item, 'name', get(item, 'caption', ''))}
                          {...thumbnailImageProps}
                        />
                      }
                      {
                        !has(item, 'contentUrl') &&
                        <Image
                          src={get(items, '[0]contentUrl')}
                          alt={get(items, '[0]name', get(items, '[0]caption', ''))}
                          {...thumbnailImageProps}
                        />
                      }
                      {
                        item.type === 'video' &&
                        <div className="Carousel_videoOverlay" />
                      }
                      {
                        item.type === 'tour' &&
                        <div className="Carousel_tourOverlay" />
                      }
                    </span>
                  </li>
                ))
              }
            </ul>
          </div>
        }
        {
          indicators &&
          <ul className="Carousel_indicatorList">
            {
              items.map((item, i) => (
                <li key={i.toString()}>
                  <span
                    className={`Carousel_indicator ${currentSlideIndex === i ? 'Carousel_indicator-active' : ''}`}
                    role="button"
                    tabIndex="0"
                    onClick={this.handleThumbnailClick(i)}
                    onKeyDown={this.handleThumbnailClick(i)}
                  >
                    <div className="sr-only">Slide {i + 1}</div>
                  </span>
                </li>
              ))
            }
          </ul>
        }
      </div>
    );
  }
}

Carousel.propTypes = {
  autoplay: PropTypes.bool,
  expandButton: PropTypes.bool,
  expandButtonContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  indicators: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({
    contentUrl: PropTypes.string,
    element: PropTypes.node,
    name: PropTypes.string,
    caption: PropTypes.string,
  })).isRequired,
  thumbnails: PropTypes.bool,
  mainImageProps: PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    exact: PropTypes.bool,
    preserve: PropTypes.bool,
  }),
  thumbnailImageProps: PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    exact: PropTypes.bool,
    preserve: PropTypes.bool,
  }),
  interval: PropTypes.number,
  className: PropTypes.string,
};

Carousel.defaultProps = {
  autoplay: false,
  expandButton: true,
  expandButtonContent: undefined,
  indicators: false,
  thumbnails: false,
  mainImageProps: undefined,
  thumbnailImageProps: undefined,
  interval: 3000,
  className: '',
};

export default Carousel;



// WEBPACK FOOTER //
// ./src/components/Carousel.js